module.exports = __webpack_public_path__ + "static/media/ourmarket1.d8f877d1.jpg";